<template>
<!-- 售后管理详情页 退款 -->
<section>
  <el-col :span="24" class="add_order_watch main_container pad_left">
    <section class="model_section">
      <p class="model_top_title">售后信息</p>
      <el-button type="danger" @click="returnUpperLevel()" style="float: right;margin: 5px 10px 0 0;">返回</el-button>
    </section>
    <!-- 售后管理信息 -->
    <div class="watch_msg table_container">
      <div style="display:flex;flex-wrap: wrap;">
        <span style="width:33%;display:flex">
          <p style="white-space: nowrap;" class="watch_first">售后单号：</p>
          <p style="width:85%;word-wrap: break-word;">{{GetAfterSaleDeatil.AsOrderNo}}</p>
        </span>
        <span style="width:33%;display:flex">
          <p style="white-space: nowrap;" class="watch_first">订单号：</p>
          <p style="width:85%;word-wrap: break-word;">{{GetAfterSaleDeatil.OrderNo}}</p>
        </span>
        <span style="width:33%;display:flex">
          <p style="white-space: nowrap;" class="watch_first">售后类型：</p>
          <p style="width:85%;word-wrap: break-word;">{{GetAfterSaleDeatil.TypeName}}</p>
        </span>
        <span style="width:33%;display:flex">
          <p style="white-space: nowrap;" class="watch_first">状态：</p>
          <p style="width:85%;word-wrap: break-word;">{{GetAfterSaleDeatil.StatusName}}</p>
        </span>
        <span style="width:33%;display:flex">
          <p style="white-space: nowrap;" class="watch_first">商品名称：</p>
          <p style="width:85%;word-wrap: break-word;">{{GetAfterSaleDeatil.GoodsName}}</p>
        </span>
        <span style="width:33%;display:flex">
          <p style="white-space: nowrap;" class="watch_first">数量：</p>
          <p style="width:85%;word-wrap: break-word;">{{GetAfterSaleDeatil.Counts}}</p>
        </span>
        <span style="width:100%;display:flex">
          <p style="white-space: nowrap;" class="watch_first">申请原因：</p>
          <p style="width:85%;word-wrap: break-word;">{{GetAfterSaleDeatil.Remark}}</p>
        </span>
        <span style="width:100%;display:flex">
          <p style="white-space: nowrap;" class="watch_first">申请图片：</p>
          <p v-for="itemImgUrl in GetAfterSaleDeatil.afterSalesImgs" :key="itemImgUrl.ImgUrl">
            <el-image :src="itemImgUrl.ImgUrl" class="imgUrl" @click="handleClickItem" :preview-src-list="[itemImgUrl.ImgUrl]"/>
          </p>
        </span>
      </div>
      <!-- 售后进度 -->
      <div class="afterSales">
        <div class="afterSalesTitle">售后进度：</div>
        <el-steps :space="130" :active="active" align-center finish-status="success">
          <el-step title="提交审核"/>
          <el-step title="商家审核">
              <div slot="description">
              <el-button @click="downToExamine()" v-if="GetAfterSaleDeatil.StatusId == 1">审核</el-button>
              </div>
          </el-step>
          <!-- 状态 驳回 -->
          <template v-if="GetAfterSaleDeatil.StatusId == 3">
              <el-step title="商家驳回"/>
          </template>
          <!-- 状态 通过 -->
          <template v-else>
            <el-step title="审核通过"/>
            <el-step title="买家发货"/>
            <el-step title="商家收货">
            <div slot="description">
                <el-button @click="confirmButton()" v-if="GetAfterSaleDeatil.StatusId == 4">收货</el-button>
            </div>
            </el-step>
            <el-step title="商家退款">
            <div slot="description">
                <el-button @click="refundButton()" v-if="GetAfterSaleDeatil.StatusId == 5">退款</el-button>
            </div>
            </el-step>
            <el-step title="完成"/>
          </template>
        </el-steps>
        <!-- <el-button @click="GetAfterSaleDeatil.StatusId += 1">下一步</el-button> -->
      </div>
      <!-- 表格 -->
      <div class="tableDiv">
        <el-table :data="GetAfterSaleDeatil.afterSalesFlows" style ="margin-top:15px">
          <el-table-column prop="StatusName" label="状态" align="center">
          <template scope="scope"><span>{{scope.row.StatusName}}</span></template>
          </el-table-column>
          <el-table-column prop="Remark" label="备注" align="center">
          <template scope="scope"><span>{{scope.row.Remark}}</span></template>
          </el-table-column>
          <el-table-column prop="WorkTime" label="时间" align="center">
          <template scope="scope"><span>{{scope.row.WorkTime}}</span></template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-col>

  <!-- 审核-弹框 -->
  <el-dialog class="add_order_cancle" width="40%" title="商家审核" :center="true" :visible.sync="isToExamine">
    <el-form>
      <el-form-item>
        <el-input type="textarea" placeholder="请输入审核备注" maxlength="200" v-model="shenmark" :rows="3"/>
      </el-form-item>
    </el-form>
    <div style="padding-left:0;text-align:center">
      <el-button type="danger" @click="rejectToExamine()">驳 回</el-button>
      <el-button type="danger" @click="adoptToExamine()">通 过</el-button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import { GetAfterSaleDeatil, AfterSelaWork_Audit, AfterSelaWork_Confirm, AfterSelaWork_BackMoney } from "../../api/api";
export default {
  data () {
    return {
      GetAfterSaleDeatil: [{
        AsOrderNo: "",
        OrderNo: "",
        TypeName: "",
        TypeId: "",
        StatusId: 1,
        StatusName: "",
        GoodsName: "",
        Counts: "",
        Remark: "",
        afterSalesImgs: [], // 售后图片集合
        afterSalesFlows: [], // 退款流水
      }],
      isToExamine: false, // 审核弹框
      RefundDetails: [],
      shenmark: "", // 审核意见
      orderdetailId: ""
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    active() {
      if(this.GetAfterSaleDeatil.StatusId == 2) {
        return 3
      } else {
        return this.GetAfterSaleDeatil.StatusId
      }
    }
  },
  methods: {
    init(){
      this.orderdetailId = this.$route.query.Id;
      let addParams = {
        afterSelaId: this.orderdetailId, // 售后单Id
      };
      GetAfterSaleDeatil(addParams).then(data => {
          this.GetAfterSaleDeatil = data.ResultObj;
          // this.GetAfterSaleDeatil.StatusId = 7
          this.total = data.RowsCount;
        })
        .catch(err => {
          this.GetAfterSaleDeatil = [];
        });

    },
    // 返回
    returnUpperLevel() {
      this.$router.go(-1);
    },
    // 审核按钮
    downToExamine() {
      this.isToExamine = true; // 审核弹框展示
    },
    // 审核通过
    adoptToExamine(val) {
      if (this.shenmark == "") {
       this.$swal({
          type:"warning",
          text:"请输入审核意见"
        })
        return false;
      }
      let addParams = {
        staffId: localStorage.Id, // 当前操作人id
        afterSelaId: this.orderdetailId, // 售后单id
        AuditType: 1,
        remark: this.shenmark,
      };
      AfterSelaWork_Audit(addParams).then(data => {
          this.$swal({
            text: "保存成功",
            type: "success"
          });
          this.isToExamine = false;
          this.init()
        })
    },
    // 驳回
    rejectToExamine(val) {
      if (this.shenmark == "") {
       this.$swal({
          type:"warning",
          text:"请输入驳回原因"
        })
        return false;
      }
      let addParams = {
        staffId: localStorage.Id, // 当前操作人id
        afterSelaId: this.orderdetailId, // 售后单id
        AuditType: 0,
        remark: this.shenmark,
      };
      AfterSelaWork_Audit(addParams).then(data => {
          this.$swal({
            text: "保存成功",
            type: "success"
          });
          this.isToExamine = false;
          this.init()
        })
    },
    // 收货按钮
    confirmButton() {
      this.$swal({
        type:'warning',
        text: '确认收货',
        showCancelButton:true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then(res => {
        if (res.value) {
          AfterSelaWork_Confirm({
            staffId: localStorage.Id, // 当前操作人id
            afterSelaId: this.orderdetailId // 售后单id
          }).then(r => {
            if(r.ResultCode == 1){
              this.$swal({
                text: "操作成功",
                type: "success"
              });
            }
            this.init();
          });
        }
      })
    },
    // 退款按钮
    refundButton() {
      this.$swal({
        type:'warning',
        text: '确认退款',
        showCancelButton:true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then(res => {
        if (res.value) {
          AfterSelaWork_BackMoney({
            staffId: localStorage.Id, // 当前操作人id
            afterSelaId: this.orderdetailId // 售后单id
          }).then(r => {
            if(r.ResultCode == 1){
              this.$swal({
                text: "操作成功",
                type: "success"
              });
            }
            this.init();
          });
        }
      })
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
}
</script>
<style scoped>
.afterSales {
  width: 100%;
  margin: 10px auto;
  padding: 15px 0 15px 10px;
  border-top: 1px solid #eee;
}
.afterSalesTitle {
  height: 50px;
  font-weight: bold;
  float: left;
}
.add_order_watch .watch_msg span .watch_first {
  color: #888;
  width: 75px;
  text-align: justify;
  text-align-last: justify;
}
.tableDiv {
  width: 88%;
  margin: 0 auto;
  padding-bottom: 20px;
}
.imgDialog {
  width: 100%;
  height: 360px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// serviceRefund.vue?1a5d33ba